export default "__VITE_ASSET__DIYC9iX7__"